export var Icon;
(function (Icon) {
    Icon["Client"] = "Client";
    Icon["Comment"] = "Comment";
    Icon["Date"] = "Date";
    Icon["Email"] = "Email";
    Icon["Employee"] = "Employee";
    Icon["File"] = "File";
    Icon["Folder"] = "Folder";
    Icon["Manual"] = "Manual";
    Icon["Number"] = "Number";
    Icon["Project"] = "Project";
    Icon["Prospect"] = "Prospect";
    Icon["Signature"] = "Signature";
    Icon["Task"] = "Task";
    Icon["Template"] = "Template";
    Icon["Text"] = "Text";
    Icon["Url"] = "Url";
    Icon["User"] = "User";
    Icon["Variable"] = "Variable";
    Icon["Workflow"] = "Workflow";
    Icon["Share"] = "Share";
})(Icon || (Icon = {}));
//# sourceMappingURL=withIcon.js.map